import { translations } from "@/shared/localization/translations";

import CartApplicableDiscountsListPopoverContent from "@/app/components/cart/CartApplicableDiscountsListPopoverContent.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class CartApplicableDiscountsListPopover extends VueContentPopover {
    constructor(options: { locationId: string; cartId: string; selectedMainCartItemIds: string[] }) {
        super({
            popoverClass: "cart-applicable-discounts-list-popover",
            title: translations.discounts.selectDiscount,
            fullscreen: true,
        });

        const props = {
            locationId: options.locationId,
            cartId: options.cartId,
            selectedMainCartItemIds: options.selectedMainCartItemIds,
            onClose: () => this.hide(),
        };
        this.initComponent(CartApplicableDiscountsListPopoverContent, props);
    }
}
